import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../../pages/Footer";
import DasboardNavbar from "./DasboardNavbar"; // Import your sidebar/navbar component
const DashboardLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // State to manage sidebar visibility
  const [isMobileView, setIsMobileView] = useState(false); // Detect if it's mobile view
  const location = useLocation();
  const [userName, setUserName] = useState(location.state?.userName || '');
  const [userId, setUserId] = useState(location.state?.userId || '');
  const [user1, setUser1] = useState();

  // useEffect(() => {
  //    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
  //     setUser1(userFromLocalStorage);
  //   if (!userName.trim() || !userId) {
  //     const urlParams = new URLSearchParams(location.search);
  //     const urlUserName = urlParams.get('userName');
  //     const urlUserId = urlParams.get('userId');

  //     if (urlUserName) {
  //       setUserName(decodeURIComponent(urlUserName)); 
  //     }
  //     else{
  //       const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
  //       setUserName(userFromLocalStorage ? userFromLocalStorage.userName : null)

  //     }
  //     if (urlUserId) {
  //       setUserId(decodeURIComponent(urlUserId));  // Decode the userId from URL
  //     }
  //     else{
  //       const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
  //       setUserId(userFromLocalStorage ? userFromLocalStorage.userId : null)
  //     }
  //   }
  // }, [userName, userId, location.search]); // Re-run effect if location.search changes


  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  // Helper function to check if token is expired
  const isTokenExpired = (token) => {
    try {
      const decodedToken = JSON.parse(atob(token.split('.')[1])); // Decode the JWT payload
      const expiryTime = decodedToken.exp * 1000; // Convert expiry to milliseconds
      // Log token expiry time in human-readable format
      // console.log("Token Expiry Time (UTC):", new Date(expiryTime).toISOString());
      // console.log("Current Time (UTC):", new Date().toISOString());
      return Date.now() > expiryTime; // Compare current time with token expiry time
    } catch (error) {
      console.error('Error decoding token', error);
      return true; // Treat token as expired if decoding fails
    }
  };

  // Function to clear cookies and localStorage
  const clearUserData = () => {
    const domain = window.location.hostname === 'localhost' ? 'localhost' : '.jobbox.one';

    // Clear cookies
    document.cookie = `user=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;
    document.cookie = `token=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;

    // Clear localStorage
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  // useEffect(() => {
  //   const tokenFromCookies = getCookie('token'); // Get token from cookies
  //   const userFromCookies = getCookie('user'); // Get user from cookies

  //   console.log("tokenFromCookies -->", tokenFromCookies);
  //   console.log("userFromCookies -->", userFromCookies);

  //   // Check localStorage for token and user
  //   const token = localStorage.getItem('token');
  //   const user = JSON.parse(localStorage.getItem('user'));

  //   console.log("userFromLocalStore -->", user);
  //   console.log("tokenFromLocalStore -->", token);

  //   // If token is missing or expired, clear data and redirect
  //   const loginUrl =
  //     window.location.hostname === "localhost"
  //       ? "http://localhost:3000/signin"
  //       : "https://app.jobbox.one/signin";

  //   if (!tokenFromCookies || isTokenExpired(tokenFromCookies)) {
  //     clearUserData();
  //     window.location.href = loginUrl; // Redirect to appropriate login page
  //     return;
  //   }

  //   // If token is valid, set user data and proceed
  //   setUser1(user);
  //   console.log("User1 inside useEffect :", user1);
  //   // If userName or userId is empty, fetch from URL query parameters or localStorage
  //   if (!userName.trim() || !userId) {
  //     const urlParams = new URLSearchParams(location.search);
  //     const urlUserName = urlParams.get('userName');
  //     const urlUserId = urlParams.get('userId');

  //     setUserName(urlUserName ? decodeURIComponent(urlUserName) : user?.userName || '');
  //     setUserId(urlUserId ? decodeURIComponent(urlUserId) : user?.userId || '');
  //   }
  // }, [userName, userId, location.search]);


  useEffect(() => {
    const tokenFromCookies = getCookie('token'); // Get token from cookies
    const userFromCookies = getCookie('user'); // Get user from cookies

    // console.log("tokenFromCookies -->", tokenFromCookies);
    // console.log("userFromCookies -->", userFromCookies);

    // Check localStorage for token and user
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));

    // console.log("userFromLocalStore -->", user);
    // console.log("tokenFromLocalStore -->", token);

    // If token is missing or expired, clear data and redirect
    const loginUrl =
      window.location.hostname === "localhost"
        ? "http://localhost:3000/signin"
        : "https://app.jobbox.one/signin";

    const userCookies = userFromCookies ? JSON.parse(userFromCookies) : null;

    // Check if token is missing or expired
    if (
      !tokenFromCookies ||
      isTokenExpired(tokenFromCookies) ||
      !userCookies?.userRole ||
      userCookies.userRole.toLowerCase() !== 'candidate'
    ) {
      clearUserData();
      window.location.href = loginUrl;
      return;
    }


    // If token is valid, set user data and proceed
    setUser1(userCookies);
    // console.log("User1 inside useEffect :", user1);

    // If userName or userId is empty, fetch from URL query parameters or localStorage
    if (!userName.trim() || !userId) {
      const urlParams = new URLSearchParams(location.search);
      const urlUserName = urlParams.get('userName');
      const urlUserId = urlParams.get('userId');

      setUserName(urlUserName ? decodeURIComponent(urlUserName) : userCookies?.userName || '');
      setUserId(urlUserId ? decodeURIComponent(urlUserId) : userCookies?.userId || '');
    }
  }, [userName, userId, location.search]);

  // console.log("User ID:", userId, "User Name:", userName);
  // console.log("User :", user1);


  useEffect(() => {
    const storedUserName = localStorage.getItem(`userName_${userId}`);
    if (storedUserName) {
      setUserName(storedUserName);
    }
  }, [userId]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1200) { // 768px is the breakpoint for mobile view
        setIsMobileView(true);
        setIsSidebarOpen(false); // Ensure sidebar is closed on mobile by default
      } else {
        setIsMobileView(false);
        setIsSidebarOpen(true); // Keep sidebar open for larger screens
      }
    };
    // Listen for window resize
    window.addEventListener("resize", handleResize);
    handleResize(); // Run once to set the initial state
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const toggleSidebar = () => {
    if (isMobileView) {
      setIsSidebarOpen(!isSidebarOpen); // Toggle sidebar visibility for mobile
    } else {
      setIsSidebarOpen(!isSidebarOpen); // Toggle sidebar visibility for larger screens
    }
  };
  const handleLinkClick = () => {
    if (isMobileView) {
      setIsSidebarOpen(false); // Close the sidebar on mobile when clicking outside
    }
  };
  // User object to pass to HrLeftSide
  // User object to pass to HrLeftSide
  const user = {
    userName: userName,
    userId: userId,
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <div style={{ display: "flex", flex: 1 }}>
        {/* Left Side: Sidebar */}
        <div
          style={{
            width: isSidebarOpen ? (isMobileView ? "10%" : "14%") : "0", // For mobile, sidebar takes 80% width when open
            height: "100%",
            overflowY: "auto",
            backgroundColor: "#F8F9FA",
            position: isMobileView ? "absolute" : "relative", // Sidebar should overlay content on mobile
            zIndex: isMobileView ? "1000" : "auto", // Ensure sidebar appears above content on mobile
            transition: "width 0.3s ease-in-out", // Smooth transition for larger screens
            //    marginLeft: isSidebarOpen ? "0" : "10px", // Add margin-left when sidebar is closed
          }}
        >
          <DasboardNavbar user={user} isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        </div>
        {/* Right Side: Main Content */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            marginTop: "80px",
            marginLeft: isMobileView ? "0" : isSidebarOpen ? "0" : "0", // No margin for mobile; adjust for sidebar on larger screens
            width: "100%", // Right side content always takes full width
            transition: isMobileView ? "none" : "margin-left 0.3s ease-in-out", // Smooth transition only on larger screens
          }}
          onClick={handleLinkClick}
        >
          {children}
          <Footer />
        </div>

      </div>

    </div>
  );
};
export default DashboardLayout;